module.exports = [
  {
    cardId: 1,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "CET Registration",
    linkText: "Register Now",
    openModal: true,
    moreLinks: [
    {
      title: "Technical Education",
      types: [
        {
          type: "UG",
          linkUrls: [
            {
              title: "MHT-CET 2025",
              linkUrl: "https://mhtcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mht_cet",
            },
            {
              title: "MAH-B.HMCT/ M.HMCT (Integrated) CET-2025",
              linkUrl: "https://bhmctcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mah_bhmct_cet",
            },
            {
              title: "MAH-B.Design-CET-2025",
              linkUrl: "https://bdesign2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mah_bdesign_cet",
            },
            {
              title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
              linkUrl: "https://bbabcacet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mah_bbabca_cet",
            },
            /* {
              title: "MAH-M.Planning Integrated CET-2025",
              linkUrl: "",
              linkText: "",
              alternativeText: "Registration Will Start Soon",
              enum: "mah_mplanning_cet",
            },
            {
              title: "MAH-M.HMCT Integrated CET-2025",
              linkUrl: "",
              linkText: "",
              alternativeText: "Registration Will Start Soon",
              enum: "mah_mhmctintegrated_cet",
            }, */
            {
              title: "MAH - B.BCA/BBA/BMS/BBM (Additional Attempt) CET 2025",
              linkUrl: "https://additional-bbabcacet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mah_bbabca_reattempt_cet",
            },
          ],
        },
        {
          type: "PG",
          linkUrls: [
            {
              title: "MAH-MBA/MMS-CET 2025",
              linkUrl: "https://mbacet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mah_mba_mms_cet",
            },
            /* {
              title: "MAH-M.Arch-CET 2025",
              linkUrl: "",
              linkText: "",
              alternativeText: "Registration Will Start Soon",
              enum: "mah_march_cet",
            }, */
            {
              title: "MAH-M.HMCT-CET 2025",
              linkUrl: "https://mhmctcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mah_mhmct_cet",
            },
            {
              title: "MAH-MCA-CET 2025",
              linkUrl: "https://mcacet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
              linkText: "",
              alternativeText: "Registration Closed.",
              enum: "mah_mca_cet",
            },
          ],
        },
      ],
    },
  {
    title: "Agriculture Education",
    types: [
      {
        type: "",
        linkUrls: [
          {
            title: "MHT-CET-2025",
            linkUrl: "https://mhtcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mht_cet",
          },
        ],
      },
    ],
  },
  {
    title: "Higher Education",
    types: [
      {
        type: "UG",
        linkUrls: [
          {
            title: "MAH-LLB (5-Years) CET-2025",
            linkUrl: "https://llb5cet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_llb_5years_cet",
          },
          {
            title: "MAH-B.Ed (General & Special) & B.Ed ELCT-CET-2025",
            linkUrl: "https://bedcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_bed_general_bed_elct_cet",
          },
          {
            title: "MAH-B.P.Ed.-CET-2025",
            linkUrl: "https://bpedcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_bped_cet",
          },
          {
            title: "MAH-L.L.B.3 Yrs. CET-2025",
            linkUrl: "https://llb3cet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_llb_3years_cet",
          },
          {
            title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
            linkUrl: "https://babscbed2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_ba_bsc_bed_4years",
          },
        ],
      },
      {
        type: "PG",
        linkUrls: [
          {
            title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
            linkUrl: "https://bedmedcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_bed_med_3years_cet",
          },
          {
            title: "M.Ed.- CET 2025",
            linkUrl: "https://medcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_med_cet",
          },
          {
            title: "M.P.Ed. - CET 2025",
            linkUrl: "https://mpedcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_mped_cet",
          },
        ],
      },
    ],
  },
  {
    title: "Medical Education",
    types: [
      {
        type: "UG",
        linkUrls: [
          {
            title: "MH-Nursing CET 2025 (For B.Sc Nursing, ANM & GNM courses)",
            linkUrl: "https://mhnursingcet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "bsc_nursing_cet",
          },
          {
            title: "MH-DPN/PHN-CET-2025",
            linkUrl: "https://dpncet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_dpnphn_cet",
          },
        ],
      },
      {
        type: "PG",
        linkUrls: [
          {
            title: "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
            linkUrl: "https://registration-forms.maharashtracet.org/mhcet/registrations?courseid=23&coursename=MAH-PGP-CET/PGO-CET/M.Sc(A&SLP)-CET/M.Sc(P&O)-CET-2025",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_pgp_pgo_msc",
          },
        ],
      },
    ],
  },
  {
    title: "Fine Art",
    types: [
      {
        type: "",
        linkUrls: [
          {
            title: "MAH-AAC CET 2025",
            linkUrl: "https://mahaaccet2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
            linkText: "",
            alternativeText: "Registration Closed.",
            enum: "mah_aac_cet",
          },
        ],
      },
    ],
  },
],
  },
  {
    cardId: 2,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/edit_profile.svg`,
    title: "Profile",
    linkText: "Edit Profile",
    editModal: true,
  },
  {
    cardId: 3,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/admin_card.svg`,
    title: "Centralized Admission Process (CAP) Registration",
    linkText: "Register Now",
    capModal: true,
    moreLinks: [
      {
        title: "Technical Education",
        types: [
          { 
            type: "UG",
            linkUrls: [
              {
                title: "B. Designing",
                linkUrl:"https://bdesigncap2025.mahacet.org/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bdesign_cap",
              },
              {
                title: "Bachelor of Engineering",
                linkUrl:"https://fe2025.mahacet.org/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_be_cap",
              },
              {
                title: "Bachelor of Hotel Management & Catering Technology",
                linkUrl:"https://dmhmct2025.mahacet.org.in/hmct/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bhmct_cap",
              },
              {
                title: "B.Pharmacy (Practice)",
                linkUrl:"https://phpractice2025.mahacet.org/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bphar_prac_cap",
              },
              {
                title: "Direct Second Year Degree in Pharmacy",
                linkUrl:"https://dsp2025.mahacet.org.in/dsp/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_sy_phar_cap",
              },
              {
                title: "Direct Second Year Degree in Engineering",
                linkUrl:"https://dse2025.mahacet.org.in/dse25/index.php/SSOController/index",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_sy_eng_cap",
              },
              {
                title: "Bachelor of Pharmacy",
                linkUrl:"https://ph2025.mahacet.org/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bphar_cap",
              },
              {
                title: "B.Planning",
                linkUrl:"https://bplanning2025.mahacet.org/RegistrationModule/frmCheckCETDetails",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_bplanning_cap",
              },
              {
                title: "Bachelor of Architecture",
                linkUrl:"https://arch2025.mahacet.org.in/arch/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_barch_cap",
              },
            ]
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "Master of Business Administration / Master of Management Studies",
                linkUrl:"https://mba2025.mahacet.org.in/cetmba25/mba25/index.php/SSOController/index",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mba_mms_cap",
              },
              {
                title: "Master of Computer Application",
                linkUrl:"https://mca2025.mahacet.org.in/mca/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mca_cap",
              },
              {
                title: "Masters of Hotel Management & Catering Technology",
                linkUrl:"https://dmhmct2025.mahacet.org.in/mhmct/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_mhmct_cap",
              },
              {
                title: "Master of Engineering",
                linkUrl:"https://me2025.mahacet.org/RegistrationModule/frmInstructionsBeforeRegistration",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_me_cap",
              },
              {
                title: "Master of Architecture",
                linkUrl:"https://march2025.mahacet.org.in/march/sso",
                linkText: "Register Now",
                alternativeText: "",
                enum: "te_march_cap",
              },
            ]
          }
        ]
      }, 
      {
        title: "Agriculture",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "Direct Second Year of Bachelor of Science (Agriculture)",
                linkUrl:"https://agripug2025.mahacet.org",
                linkText: "Register Now",
                alternativeText: "",
                enum: "ag_sy_bsc_ug_cap",
              },
              {
                title: "Bachelor of Agriculture & Allied Courses",
                linkUrl:"https://agri2025.mahacet.org/ApplicationFormLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "ag_common_ug_cap",
              },
            ]
          }
        ]
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "Bachelor of Education, Master’s in Education (Integrated)",
                linkUrl:"https://bedmedcap25.mahacet.org/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_bed_med_cap",
              },
              {
                title: "Bachelor of Education",
                linkUrl:"https://bedcap25.mahacet.org/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_bed_cap",
              },
              {
                title: "Bachelor of Law 5 Years (Integrated)",
                linkUrl:"https://llb5cap25.mahacet.org/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_llb_5years_cap",
              },
              {
                title: "Bachelor of Law 3 Years",
                linkUrl:"https://llb3cap25.mahacet.org/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_llb_3years_cap",
              },
              {
                title: "Bachelor of Physical Education",
                linkUrl:"https://bpedcap25.mahacet.org/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_bped_cap",
              },
            ]
          },
          {
            type: "PG",
            linkUrls: [
            {
                title: "Master of Education",
                linkUrl:"https://medcap25.mahacet.org/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_med_cap",
              },
              {
                title: "Master of Physical Education",
                linkUrl:"https://mpedcap25.mahacet.org/Public/CheckCandidateLogin.aspx",
                linkText: "Register Now",
                alternativeText: "",
                enum: "he_mped_cap",
              },
              
            ]
          } 
        ]
      },
      {
        title: "Medical and Ayush Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "Bachelor of Science in Nursing",
                linkUrl:"https://medicalug2025.mahacet.org/NURSING2025/",
                linkText: "Register Now",
                alternativeText: "",
                enum: "mae_bsn_cap",
              },              
            ]
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "Post-Graduation in Dental (MDS)",
                linkUrl:"https://medical2025.mahacet.org/NEET-PGD-2025/",
                linkText: "",
                alternativeText: "Registration Closed.",
                enum: "mae_mds_cap",
              }, 
            ]
          } 
        ]
      },
      {
        title: "Fine Art Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "Bachelor of Fine Art",
                linkUrl:"https://fineart2025.mahacet.org/FINEART2025/",
                linkText: "Register Now",
                alternativeText: "",
                enum: "fae_common_ug_cap",
              },              
            ]
          }
        ]
      },
    ]
  },
  {
    cardId: 4,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/student_registration.svg`,
    title: "MOCK & Psychometric Test",
    linkText: "Register Now",
    linkUrl: "https://mocktest.mahacet.org/StaticPages/homepage",
  },
  {
    cardId: 5,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/support-ticket.svg`,
    title: "Help Desk",
    linkText: "Create or Track Issues",
    linkUrl: "https://helpdesk.maharashtracet.org/login.php?do=ext&bk=oauth2.user.p1i2",
  },
  {
    cardId: 6,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/hall_ticket.svg`,
    title: "Hall Ticket or Admit Card",
    linkText: "Get Hall Ticket",
    openModal: true,
    moreLinks: [
      {
        title: "Technical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MHT-CET (PCB) 2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-PCB-Z3W7Q6NP/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-PCM-Y3X9L7QP/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mht_cet",
              },
              {
                title: "MAH-B.HMCT/ M.HMCT (Integrated) CET-2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-M-HMCT-INT-X8F2BMC7",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bhmct_cet",
              },
               {
                 title: "MAH-B.Design-CET-2025",
                 linkUrl: "https://admitcard.mhexam.com/MAH-BDesign-X7P3J9BK/",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_bdesign_cet",
               },
               {
                title: "MAH-M.HMCT Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mhmctintegrated_cet",
              },
               {
                title: "MAH-M.Planning Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mplanning_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-BBA-BMS-MPYH35BG/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bbabca_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM/ MBA(Int)/MCA(Int) CET 2025 (Additional Attempt)",
                linkUrl: "https://admitcard.mhexam.com/MAH-BBA-BMS-Z1V8M6KT/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bbabca_reattempt_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                 title: "MAH-MBA/MMS-CET 2025",
                 linkUrl: "https://admitcard.mhexam.com/MAH-MBA-J7XG4P9W/",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_mba_mms_cet",
              },
              {
                title: "MAH-M.Arch-CET 2025",
                linkUrl: "",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_march_cet",
              },
              {
                title: "MAH-M.HMCT-CET 2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-M-HMCT-7GJ5PL2X",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mhmct_cet",
              },
              {
                 title: "MAH-MCA-CET 2025",
                 linkUrl: "https://admitcard.mhexam.com/MAH-MCA-A3X7C9G2",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_mca_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Agriculture Education",
        types: [
          {
            type: "",
            linkUrls: [
              // {
              //   title: "MHT-CET-2025",
              //   linkUrl: "",
              //   linkText: "Get Hall Ticket",
              //   alternativeText: "",
              //   enum: "mht_cet",
              // },
            ],
          },
        ],
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MAH-LLB (5-Years) CET-2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-LLB5-KCW71L0Q",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_llb_5years_cet",
               }, 
               {
                 title: "MAH-B.Ed (General & Special) & B.Ed ELCT-CET-2025",
                 linkUrl: "https://admitcard.mhexam.com/MAH-BED-A1B2C3D4",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_bed_general_bed_elct_cet",
               },
               {
                 title: "MAH-B.P.Ed.-CET-2025",
                 linkUrl: "https://admitcard.mhexam.com/MAH-BPED-Z4T9L2QF",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_bped_cet",
               },
               {
                 title: "MAH-L.L.B.3 Yrs. CET-2025",
                 linkUrl: "https://admitcard.mhexam.com/MAH-LLB3-N7X2M9QL/",
                 linkText: "Get Hall Ticket",
                 alternativeText: "",
                 enum: "mah_llb_3years_cet",
               },
              {
                title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
                linkUrl:"https://admitcard.mhexam.com/Bed-INT-G7X2B9QA/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_ba_bsc_bed_4years",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-BED-MED-X9FQ2K7J/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_bed_med_3years_cet",
              },
              {
                title: "MAH-M.Ed CET-2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-M-Ed-CET-2025/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_med_cet",
              },
              {
                title: "MAH-M.P.Ed. CET",
                linkUrl: "https://admitcard.mhexam.com/MAH-M-P-Ed-CET-2025",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_mped_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Medical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MH-Nursing CET 2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-Nursing-X5N2Q8WZ",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "bsc_nursing_cet",
              },
              {
                title: "MH-DPN/PHN-CET-2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-DPN-PHN-L9X2G7WM",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_dpnphn_cet",
              },
              {
                title: "MAH-PGP-CET / PGO-CET / M.Sc(A & SLP)-CET / M.Sc(P & O)-CET-2025",
                linkUrl: "https://admitcard.mhexam.com/MAH-PGP-HTEB7E4K",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_pgp_pgo_msc",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              // {
              //   title:
              //     "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
              //   linkUrl: "",
              //   linkText: "Get Hall Ticket",
              //   alternativeText: "",
              //   enum: "mah_pgp_pgo_msc",
              // },
            ],
          },
        ],
      },
      {
        title: "Fine Art",
        types: [
          {
            type: "",
            linkUrls: [
              {
                title: "MAH-AAC CET",
                linkUrl: "https://admitcard.mhexam.com/MAH-FineArts-T6M4L9QX/",
                linkText: "Get Hall Ticket",
                alternativeText: "",
                enum: "mah_aac_cet",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    cardId: 7,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/objection_tracking.svg`,
    title: "Objection Tracker",
    linkText: "Track Here",
    openModal: true,
    moreLinks: [
      {
        title: "Technical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              /*{
                title: "MHT-CET (PCB) 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },*/
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "https://ot.mhexam.com/PCM-K3X9M7QL",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCB) 2025",
                linkUrl: "https://ot.mhexam.com/PCB-T9X4M7QL",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              },
              {
                title: "MAH-B.HMCT/ M.HMCT (Integrated) CET-2025",
                linkUrl: "https://ot.mhexam.com/BHMCT-W4X9M7QP",
                linkText: "Raise an Objection",
                enum: "mah_bhmct_cet",
              },
              {
                title: "MAH-B.Design-CET-2025",
                linkUrl: "https://ot.mhexam.com/B-Design-R2X7M5CR-R/",
                linkText: "Raise an Objection",
                enum: "mah_bdesign_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
                linkUrl: "https://ot.mhexam.com/BBA-X9M7L2QP",
                linkText: "Raise an Objection",
                enum: "mah_bbabca_cet",
              },
              {
                title: "MAH-M.Planning Integrated CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_mplanning_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM/ MBA(Int)/MCA(Int) CET 2025 (Additional Attempt)",
                linkUrl: "https://ot.mhexam.com/BBA-INT-M2X7L9QP",
                linkText: "Raise an Objection",
                enum: "mah_bbabca_reattempt_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
               {
                title: "MAH-MBA/MMS-CET 2025",
                linkUrl: "https://ot.mhexam.com/MBA-P7X9L3QW",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mba_mms_cet",
              }, 
              {
                title: "MAH-M.Arch-CET 2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_march_cet",
              },
              {
                title: "MAH-M.HMCT-CET 2025",
                linkUrl: "https://ot.mhexam.com/MHMCT-J4X7M9QP",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mhmct_cet",
              },
               {
                title: "MAH-MCA-CET 2025",
                linkUrl: "https://ot.mhexam.com/MCA-F3N7L9WX",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mca_cet",
              },
              {
                title: "MAH-M.HMCT Integrated CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_mhmctintegrated_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MAH-LLB (5-Years) CET-2025",
                linkUrl: "https://ot.mhexam.com/LLB5-W9X2M7QL",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_llb_5years_cet",
              },
              {
                title: "MAH-B.Ed (General & Special)",
                linkUrl: "https://ot.mhexam.com/BEd-M4X7Q9LP",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_bed_general_bed_elct_cet",
              },
              {
                title: "MAH-B.Ed ELCT-CET-2025",
                linkUrl: "https://ot.mhexam.com/ELCT-Z8X3L7QP",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_bed_general_bed_elct_cet",
              }, 
              {
                title: "MAH-B.P.Ed.-CET-2025",
                linkUrl: "https://ot.mhexam.com/BPED-X7Q9L2WM",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_bped_cet",
              },
               {
                title: "MAH-L.L.B.3 Yrs. CET-2025",
                linkUrl: "https://ot.mhexam.com/LLB3-M7X9L2QP",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_llb_3years_cet",
              },
             {
                title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
                linkUrl: "https://ot.mhexam.com/BA-BSC-INT-V8Q3X7WL",
                linkText: "Raise an Objection",
                alternativeText: "",
                enum: "mah_ba_bsc_bed_4years",
              }, 
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
                linkUrl: "https://ot.mhexam.com/BEd-MEd-V6Q3X9LP",
                linkText: "Raise an Objection",
                enum: "mah_bed_med_3years_cet",
              },
              {
                title: "MAH-M.Ed CET-2025",
                linkUrl: "https://ot.mhexam.com/MED-K2W8Q7ML",
                linkText: "Raise an Objection",
                enum: "mah_med_cet",
              },
              {
                title: "MAH-M.P.Ed. CET",
                linkUrl: "https://ot.mhexam.com/MPED-Q7X4M2LP/",
                linkText: "Raise an Objection",
                enum: "mah_mped_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Medical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
              {
                title: "MH-Nursing CET 2025",
                linkUrl: "https://ot.mhexam.com/Nursing-G9X4M7LP",
                linkText: "Raise an Objection",
                enum: "bsc_nursing_cet",
              },
              {
                title: "MH-DPN/PHN-CET-2025",
                linkUrl: "https://ot.mhexam.com/DPN-PHN-R2X7M9QP",
                linkText: "Raise an Objection",
                enum: "mah_dpnphn_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
                linkUrl: "https://ot.mhexam.com/PGP-HW6D7JA",
                linkText: "Raise an Objection",
                enum: "mah_pgp_pgo_msc",
              },
            ],
          },
        ],
      },
      {
        title: "Fine Arts",
        types: [
          {
            type: "",
            linkUrls: [
              /* {
                title: "MAH-AAC CET",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mah_aac_cet",
              }, */
              {
                title: "MAH-AAC CET",
                linkUrl: "https://ot.mhexam.com/Fine-Arts-T6X9M4QL-R/",
                linkText: "Raise an Objection",
                enum: "mah_aac_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Agriculture Education",
        types: [
          {
            type: "",
            linkUrls: [
              /* {
                title: "MHT-CET-2025",
                linkUrl: "",
                linkText: "Raise an Objection",
                enum: "mht_cet",
              }, */
            ],
          },
        ],
      },
    ],
  },
  {
    cardId: 8,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/score_card.svg`,
    title: "Score Card",
    linkText: "Get Score Card",
    openModal: true,
    moreLinks: [
      {
        title: "Technical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
             /* {
                title: "MHT-CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mht_cet",
              }, */
              {
                title: "MHT-CET (PCB) 2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-PCB-Q2NH7XLC/",
                linkText: "Get Score Card",
                enum: "mht_cet",
              },
              {
                title: "MHT-CET (PCM) 2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-PCM-R9TN5WQE/",
                linkText: "Get Score Card",
                enum: "mht_cet",
              },
              {
                title: "MAH-B.HMCT/ M.HMCT (Integrated) CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-M-HMCT-INT-B7X9M4QP/",
                linkText: "Get Score Card",
                enum: "mah_bhmct_cet",
              },
              {
                title: "MAH-B.Design-CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-B-Design-B6XJ2VYM/",
                linkText: "Get Score Card",
                enum: "mah_bdesign_cet",
              },
              {
                title: "MAH-M.HMCT Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mhmctintegrated_cet",
              },
              {
                title: "MAH-M.Planning Integrated CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_mplanning_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM CET 2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-BBA-P3ZK8QYU/",
                linkText: "Get Score Card",
                enum: "mah_bbabca_cet",
              },
              {
                title: "MAH - B.BCA/BBA/BMS/BBM/ MBA(Int)/MCA(Int) CET 2025 (Additional Attempt)",
                linkUrl: "https://scorecard.mhexam.com/MAH-BBA-INT-J9X2M7QL/",
                linkText: "Get Score Card",
                enum: "mah_bbabca_reattempt_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-MBA/MMS-CET 2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-MBA-N7X2M9QL/",
                linkText: "Get Score Card",
                enum: "mah_mba_mms_cet",
              }, 
              {
                title: "MAH-M.Arch-CET 2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mah_march_cet",
              },
              {
                title: "MAH-M.HMCT-CET 2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-MHMCT-Z8M2T4LC/",
                linkText: "Get Score Card",
                enum: "mah_mhmct_cet",
              },
              {
                title: "MAH-MCA-CET 2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-MCA-Z3W7Q6NP/",
                linkText: "Get Score Card",
                enum: "mah_mca_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Higher Education",
        types: [
          {
            type: "UG",
            linkUrls: [
             {
                title: "MAH-LLB (5-Years) CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-LLB5-X7FJ9LPA/",
                linkText: "Get Score Card",
                enum: "mah_llb_5years_cet",
              },
              {
                title: "MAH-B.Ed. (General)",
                linkUrl: "https://scorecard.mhexam.com/MAH-B-Ed-G7X9M4QP/",
                linkText: "Get Score Card",
                enum: "mah_bed_general_bed_elct_cet",
              },
              {
                title: "MAH-B.Ed & B.Ed ELCT",
                linkUrl: "https://scorecard.mhexam.com/MAH-ELCT-R2X7M9QL/",
                linkText: "Get Score Card",
                enum: "mah_bed_general_bed_elct_cet",
              },
              {
                title: "MAH-B.P.Ed.-CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-B-P-Ed-K2W8Q7ML/",
                linkText: "Get Score Card",
                enum: "mah_bped_cet",
              },
              {
                title: "MAH-L.L.B.3 Yrs. CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-LLB3-T8GR5WZN/",
                linkText: "Get Score Card",
                enum: "mah_llb_3years_cet",
              },
              {
                title: "MAH-B.A/B.Sc-B.Ed (4 Year Integrated course)-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-BED-INT-F6Q8L3WP/",
                linkText: "Get Score Card",
                enum: "mah_ba_bsc_bed_4years",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
              {
                title: "MAH-B.Ed.-M.Ed. (3-Year Integrated Course) – CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-B-Ed-M-Ed-X7F9B2QZ/",
                linkText: "Get Score Card",
                enum: "mah_bed_med_3years_cet",
              },
              {
                title: "MAH-M.Ed CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-M-Ed-H3K7Y9WP/",
                linkText: "Get Score Card",
                enum: "mah_med_cet",
              },
              {
                title: "MAH-M.P.Ed. CET",
                linkUrl: "https://scorecard.mhexam.com/MAH-M-P-Ed-Q7X4M2LP",
                linkText: "Get Score Card",
                enum: "mah_mped_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Medical Education",
        types: [
          {
            type: "UG",
            linkUrls: [
             {
                title: "MH-Nursing CET 2025 (For B.Sc Nursing, ANM & GNM courses)",
                linkUrl: "https://scorecard.mhexam.com/MAH-Nursing-Y3X9L7QP/",
                linkText: "Get Score Card",
                enum: "bsc_nursing_cet",
              },
              {
                title: "MH-DPN/PHN-CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-DPN-PHN-L9X2G7WM/",
                linkText: "Get Score Card",
                enum: "mah_dpnphn_cet",
              },
            ],
          },
          {
            type: "PG",
            linkUrls: [
             {
                title: "MAH-PGP-CET / PGO-CET / M.Sc(A& SLP)-CET / M.Sc(P & O)-CET-2025",
                linkUrl: "https://scorecard.mhexam.com/MAH-PGP-GR8D3NW/",
                linkText: "Get Score Card",
                enum: "mah_pgp_pgo_msc",
              },
            ],
          },
        ],
      },
      {
        title: "Fine Arts",
        types: [
          {
            type: "",
            linkUrls: [
             {
                title: "MAH-AAC CET",
                linkUrl: "https://scorecard.mhexam.com/MAH-FineArts-N7Q2X9WL/",
                linkText: "Get Score Card",
                enum: "mah_aac_cet",
              },
            ],
          },
        ],
      },
      {
        title: "Agriculture Education",
        types: [
          {
            type: "",
            linkUrls: [
             /* {
                title: "MHT-CET-2025",
                linkUrl: "",
                linkText: "Get Score Card",
                enum: "mht_cet",
              }, */
            ],
          },
        ],
      },
    ],
  }, 
  {
    cardId: 9,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/admin_card.svg`,
    title: "ARA",
    linkText: "Get Details",
    linkUrl: "",
  },
  {
    cardId: 10,
    icon: `${process.env.PUBLIC_URL}/assets/images/icons/notification.svg`,
    title: "Notifications",
    linkText: "Get Details",
    linkUrl: "https://cetcell.mahacet.org/notices/",
  },
];
